export default __webpack_public_path__ + "static/media/IMG-20241210-WA0012.d5f778fe.jpg";